import {
  Swiper as SwiperCore,
  Navigation,
  Pagination,
  Scrollbar,
  A11y,
  Autoplay,
  Grid
} from 'swiper';

import './Swiper.scss';

SwiperCore.use([Navigation, Pagination, Scrollbar, A11y, Autoplay, Grid]);

export { Swiper } from 'swiper/react';
